import { Box, Heading, Image, Text, Stack } from "@chakra-ui/react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
export const Massageservice = () => {
  var settings = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2200,
    pauseOnHover: true,
  };
  return (
    <Box textAlign={"center"} mt={"20px"} bgColor={"white"} pt={"50px"} pb={"50px"}>
      <Heading>Salon, Spa and Massage services</Heading>
      <Text as={"small"} fontWeight={"light"} pb={"50px"}>
        Hygenic & Single use products | Low-contact services
      </Text>
      <Stack width={"60%"} margin={"auto"} mt={"16vh"} gap={"10px"}>
        <Slider {...settings}>
          <Box alignItems={"center"}>
            <Image
              src={
                "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_532/t_high_res_category/images/growth/home-screen/1603078782132-dfcd55.jpeg"
              }
              borderRadius={"5px"}
              width={"90%"}
            />
            <Text>Salon Prime</Text>
            <Text as={"small"}>Free Waxing</Text>
          </Box>
          <Box alignItems={"center"}>
            <Image
              src={
                "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_532/t_high_res_category/images/growth/home-screen/1615874646690-66ab68.jpeg"
              }
              h={"15vh"}
              borderRadius={"5px"}
              width={"90%"}
            />
            <Text>Salon For Men</Text>
            <Text>Flat ₹100 Off</Text>
          </Box>
          <Box alignItems={"center"}>
            <Image
              src={
                "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_532/t_high_res_category/images/supply/customer-app-supply/1606211470897-f4afbc.jpeg"
              }
              h={"15vh"}
              borderRadius={"5px"}
              width={"90%"}
            />
            <Text>Spa for Women</Text>
            <Text as={"small"} fontWeight={"light"}>
              Free Head Massage
            </Text>
          </Box>
          <Box alignItems={"center"}>
            <Image
              src={
                "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_532/t_high_res_category/categories/category_v2/category_9b68f7b0.jpeg"
              }
              h={"15vh"}
              borderRadius={"5px"}
              width={"90%"}
            />
            <Text>Spa for Women</Text>
            <Text as={"small"} fontWeight={"light"}>
              Free Head Massage
            </Text>
          </Box>
          <Box alignItems={"center"}>
            <Image
              src={
                "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_532/t_high_res_category/images/growth/home-screen/1635829954373-d05590.jpeg"
              }
              h={"15vh"}
              borderRadius={"5px"}
              width={"90%"}
            />
            <Text>Spa for Women</Text>
            <Text as={"small"} fontWeight={"light"}>
              Free Head Massage
            </Text>
          </Box>
        </Slider>
      </Stack>
    </Box>
  );
};
